module.exports = __webpack_public_path__ + "img/Review.31f0dfab.png";